import React from "react";
import WelcomeAdminContainer from "../../container/admin/welcomeAdmin/welcomeAdminContainer";
import WelcomeAdminContextProvider from "../../container/admin/welcomeAdmin/context/welcomeAdminContext";

const WelcomeAdmin = (): React.JSX.Element => (
  <WelcomeAdminContextProvider>
    <WelcomeAdminContainer />
  </WelcomeAdminContextProvider>
);

export default WelcomeAdmin;
